<div class="{{ onboardingType }}">
  <app-onboarding-wrapper>
    <div class="d-flex flex-column align-items-sm-center">
      <ng-content></ng-content>
    </div>
  </app-onboarding-wrapper>
</div>
